<template>
  <avtalat-modal
    :idealHeight="450"
    :idealWidth="600"
    :closeOnClickOutside="true"
    :closeOnEsc="true"
    :closeFn="props.onClose"
  >
    <div class="flex">
      <button
        class="absolute right-md top-sm p-xs"
        data-testid="redigera-intern-kommentar-close-button"
        @click="onClose"
      >
        <avtalat-icon class="text-black" id="kryss-enkelt" :size="15" />
      </button>
    </div>
    <form
      class="flex flex-col gap-sm pb-sm"
      id="redigera-intern-kommentar-modal"
      @submit="onSubmitForm"
    >
      <avtalat-input
        id="redigera-intern-kommentar"
        v-model:value="internKommentarText"
        label="Intern kommentar"
        helpText="Interna kommentarer är ej synliga för kunden"
        type="textarea"
        :required="true"
        placeholder="Skriv en intern kommentar"
      />
      <div class="h-md">
        <FormErrorMessage name="internKommentarText" />
      </div>
      <div class="flex flex-row justify-end gap-md">
        <a
          class="my-2xs font-normal"
          id="redigera-intern-kommentar-avbryt-button"
          href="#"
          @click.stop.prevent="props.onClose"
          data-testid="copy-to-clipboard"
          >Avbryt</a
        >
        <avtalat-button
          id="redigera-intern-kommentar-spara-button"
          :disabled="!meta.valid"
          :loading="isSubmitting"
          >Spara</avtalat-button
        >
      </div>
    </form>
  </avtalat-modal>
</template>

<script setup lang="ts">
import { toTypedSchema } from "@vee-validate/zod";
import { useField, useForm } from "vee-validate";
import { onUnmounted } from "vue";
import { z } from "zod";

import FormErrorMessage from "../ui/FormErrorMessage.vue";

const props = defineProps<{
  onSubmit: (text: string) => Promise<void>;
  onClose: () => void;
  initialValue: string;
}>();

const formSchema = toTypedSchema(
  z.object({
    internKommentarText: z
      .string()
      .min(1, "Intern kommentar måste anges")
      .max(1000, "Får inte överskrida 1000 tecken"),
  }),
);

const { meta, handleSubmit, isSubmitting } = useForm({
  validationSchema: formSchema,
  initialValues: {
    internKommentarText: props.initialValue,
  },
  validateOnMount: true,
});

const { value: internKommentarText } = useField<string>("internKommentarText");

const onSubmitForm = handleSubmit(async (values) => {
  await props.onSubmit(values.internKommentarText);
});

onUnmounted(() => {
  props.onClose();
});
</script>
